"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBinary = void 0;
function isBinary(str) {
    if (typeof str !== "string")
        return false;
    for (var i = 0; i < str.length; i++) {
        var ch = str[i];
        if (!(ch === "0" || ch === "1"))
            return false;
    }
    return true;
}
exports.isBinary = isBinary;
